import { render, staticRenderFns } from "./DetailsLodging.vue?vue&type=template&id=680c3399&scoped=true"
import script from "./DetailsLodging.vue?vue&type=script&lang=js"
export * from "./DetailsLodging.vue?vue&type=script&lang=js"
import style0 from "./DetailsLodging.vue?vue&type=style&index=0&id=680c3399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c3399",
  null
  
)

export default component.exports